import axios from "axios";
//const base_url = 'http://127.0.0.1:4500';
//const base_url_thana = 'http://127.0.0.1:4500';

const base_url = 'https://paymentgateways.thana.la/pgapi';
const base_url_thana = 'https://paymentgateways.thana.la/pgapi';

export default axios.create({
    baseURL: base_url
});

export const axiosPrivate = axios.create({
    baseURL: base_url,
    //headers: { 'Content-Type': 'application/json' },
    //headers: { 'Content-Type': 'multipart/form-data' }
});

// Use for req to api with out loggin then need to set static token to verify with api
export const axiosPrivateStatic = axios.create({
    baseURL: base_url,
    timeout: 30000, // 30 seconds timeout
    headers: {
        'Authorization': `Bearer jsfgfjguwrg8783wgbjs849h2fu3cnsvh8wyr8fhwfvi2g225`, // Your static token
        'Content-Type': 'application/json'
    }
});

export const api_ip = () => {
    return base_url
};

export const thana_api_ip = () => {
    return base_url_thana
};